import {Action} from '@ngrx/store';
import {
  DeleteFloorRequest,
  DeleteFloorResponse,
  Floor,
  GetOrganizationFloorsRequest,
  PostFloorPlanImageRequest,
  PostFloorRequest,
  PutFloorDevicesRequest
} from '../models/floor';
import {ErrorPayload, Simple200Response} from '../models/general';

export enum FloorPlanActionTypes {
  GetOrganizationFloors = '[FloorPlan] Get Organization Floors',
  GetOrganizationFloorsComplete = '[FloorPlan] Get Organization Floors Complete',
  GetOrganizationFloorsError = '[FloorPlan] Get Organization Floors Error',
  PostFloor = '[FloorPlan] Post Floor',
  PostFloorComplete = '[FloorPlan] Post Floor Complete',
  PostFloorError = '[FloorPlan] Post Floor Error',
  PostFloorPlanImage = '[FloorPlan] Post Floor Plan Image',
  PostFloorPlanImageComplete = '[FloorPlan] Post Floor Plan Image Complete',
  PostFloorPlanImageError = '[FloorPlan] Post Floor Plan Image Error',
  PutFloorDevices = '[FloorPlan] Put Floor Devices',
  PutFloorDevicesComplete = '[FloorPlan] Put Floor Devices Complete',
  PutFloorDevicesError = '[FloorPlan] Put Floor Devices Error',
  DeleteFloor = '[FloorPlan] Delete Floor',
  DeleteFloorComplete = '[FloorPlan] Delete Floor Complete',
  DeleteFloorError = '[FloorPlan] Delete Floor Error'
}

export class GetOrganizationFloors implements Action {
  readonly type = FloorPlanActionTypes.GetOrganizationFloors;

  constructor(public payload: GetOrganizationFloorsRequest) {
  }
}

export class GetOrganizationFloorsComplete implements Action {
  readonly type = FloorPlanActionTypes.GetOrganizationFloorsComplete;

  constructor(public payload: Floor[]) {
  }
}

export class GetOrganizationFloorsError implements Action {
  readonly type = FloorPlanActionTypes.GetOrganizationFloorsError;

  constructor(public payload: ErrorPayload) {
  }
}

export class PostFloor implements Action {
  readonly type = FloorPlanActionTypes.PostFloor;

  constructor(public payload: PostFloorRequest) {
  }
}

export class PostFloorComplete implements Action {
  readonly type = FloorPlanActionTypes.PostFloorComplete;

  constructor(public payload: Floor) {
  }
}

export class PostFloorError implements Action {
  readonly type = FloorPlanActionTypes.PostFloorError;

  constructor(public payload: ErrorPayload) {
  }
}

export class DeleteFloor implements Action {
  readonly type = FloorPlanActionTypes.DeleteFloor;

  constructor(public payload: DeleteFloorRequest) {
  }
}

export class DeleteFloorComplete implements Action {
  readonly type = FloorPlanActionTypes.DeleteFloorComplete;

  constructor(public payload: DeleteFloorResponse) {
  }
}

export class DeleteFloorError implements Action {
  readonly type = FloorPlanActionTypes.DeleteFloorError;

  constructor(public payload: ErrorPayload) {
  }
}

export class PostFloorPlanImage implements Action {
  readonly type = FloorPlanActionTypes.PostFloorPlanImage;

  constructor(public payload: PostFloorPlanImageRequest) {
  }
}

export class PostFloorPlanImageComplete implements Action {
  readonly type = FloorPlanActionTypes.PostFloorPlanImageComplete;

  constructor(public payload: Simple200Response) {
  }
}

export class PostFloorPlanImageError implements Action {
  readonly type = FloorPlanActionTypes.PostFloorPlanImageError;

  constructor(public payload: ErrorPayload) {
  }
}

export class PutFloorDevices implements Action {
  readonly type = FloorPlanActionTypes.PutFloorDevices;

  constructor(public payload: PutFloorDevicesRequest) {
  }
}

export class PutFloorDevicesComplete implements Action {
  readonly type = FloorPlanActionTypes.PutFloorDevicesComplete;

  constructor(public payload: Simple200Response) {
  }
}

export class PutFloorDevicesError implements Action {
  readonly type = FloorPlanActionTypes.PutFloorDevicesError;

  constructor(public payload: ErrorPayload) {
  }
}

export type FloorActions =
  | GetOrganizationFloors
  | GetOrganizationFloorsComplete
  | GetOrganizationFloorsError
  | PostFloor
  | PostFloorComplete
  | PostFloorError
  | DeleteFloor
  | DeleteFloorComplete
  | DeleteFloorError
  | PostFloorPlanImage
  | PostFloorPlanImageComplete
  | PostFloorPlanImageError
  | PutFloorDevices
  | PutFloorDevicesComplete
  | PutFloorDevicesError;
